// src/TP/CoreBundle/Resources/public/tp_core.js

import sendEmail from 'tp_user/js/sendEmail.js';

$(function() {
    sendEmail.initialize();
});
